import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { Microphone, MicrophoneSlash, Warning, ArrowUp } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { MicButtonProps } from "@/types";
export function MicButton(t0) {
  const $ = _c(19);
  const {
    isRecording,
    isProcessingSpeech,
    micPermission,
    startRecording,
    stopRecording,
    hasText,
    onSend
  } = t0;
  if (micPermission === "checking") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10" disabled={true}><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></Button>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (micPermission === "denied" && !hasText) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <MicrophoneSlash className="w-5 h-5 text-red-500" weight="fill" />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10 group relative" onClick={_temp} title="Microphone access denied. Click for help.">{t1}<span className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><Warning className="w-3 h-3 text-white" weight="bold" /></span></Button>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (hasText) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ArrowUp className="w-5 h-5 text-foreground" weight="bold" />;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== isProcessingSpeech || $[5] !== onSend) {
      t2 = <Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10 hover:bg-primary/10" onClick={onSend} disabled={isProcessingSpeech}>{t1}</Button>;
      $[4] = isProcessingSpeech;
      $[5] = onSend;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  if (isRecording) {
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <MicrophoneSlash className="w-5 h-5 text-red-500 animate-pulse" weight="fill" />;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t2;
    if ($[8] !== isProcessingSpeech || $[9] !== stopRecording) {
      t2 = <Button variant="ghost" size="icon" className="h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10" onClick={stopRecording} disabled={isProcessingSpeech}>{t1}</Button>;
      $[8] = isProcessingSpeech;
      $[9] = stopRecording;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    return t2;
  }
  const t1 = micPermission === "granted" && "hover:bg-primary/10";
  let t2;
  if ($[11] !== t1) {
    t2 = cn("h-11 w-11 shrink-0 rounded-none hover:bg-muted-foreground/10", t1);
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  const t3 = isProcessingSpeech ? "Processing speech..." : "Start voice recording";
  let t4;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Microphone className="w-5 h-5" weight="fill" />;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== isProcessingSpeech || $[15] !== startRecording || $[16] !== t2 || $[17] !== t3) {
    t5 = <Button variant="ghost" size="icon" className={t2} onClick={startRecording} disabled={isProcessingSpeech} title={t3}>{t4}</Button>;
    $[14] = isProcessingSpeech;
    $[15] = startRecording;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp() {
  alert("Microphone access is blocked. To enable voice input:\n\n1. Click the lock/site settings icon in your browser's address bar\n2. Allow microphone access\n3. Refresh this page");
}